import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-paper-plant",
  "use": "icon-icon-paper-plant-usage",
  "viewBox": "0 0 15.3 13.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.3 13.1\" id=\"icon-icon-paper-plant\">\r\n    <defs>\r\n        <style>#icon-icon-paper-plant .cls-1{opacity:0.97;}</style>\r\n    </defs>\r\n    <title>资源 120</title>\r\n    <g id=\"icon-icon-paper-plant_图层_2\" data-name=\"图层 2\">\r\n        <g id=\"icon-icon-paper-plant_图层_1-2\" data-name=\"图层 1\">\r\n            <path class=\"cls-1\" d=\"M15.3,1.2l-2,11.1c-.2.7-.6.9-1.3.6L8.4,10.4,6.7,12.1a.9.9,0,0,1-.7.3l.2-3.6,6.4-6.1c.3-.3-.1-.4-.5-.1l-8,5.3L.6,6.9c-.8-.2-.8-.7.1-1.1L14.3.1C14.9-.2,15.5.2,15.3,1.2Z\" />\r\n        </g>\r\n    </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-paper-plant.svg
// module id = mh7v
// module chunks = 72